<template>
    <section>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 grid-margin">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="mb-0">Lista missioni</h5>
                        </div>
                        <div class="card-body p-0">
                            <paginated-table
                                v-if="projects.data"
                                v-model="query"
                                :columns="columns"
                                :data="projects.data"
                                :total="projects.total"
                                :clickRow="true"
                                @rowClicked="rowClicked"
                            >
                                <template slot="project_status" slot-scope="props">
                                    <span class="status" :class="[calculateProgress(props.row) === 0 ? 'not-started' : calculateProgress(props.row) === 100 ? 'completed' : 'running']"></span>
                                </template>
                                <template slot="project_name" slot-scope="props">
                                    {{ props.row.project_name || '--' }}
                                </template>
                                <template slot="creator_username" slot-scope="props">
                                    {{ props.row.creator.username || '--' }}
                                </template>
                                <template slot="company_username" slot-scope="props">
                                    {{ props.row.company.username || '--' }}
                                </template>
                                <template slot="tasks_length" slot-scope="props">
                                    {{ props.row.tasks.length }}
                                </template>
                                <template slot="progress" slot-scope="props">
                                    <!-- <progress-bar v-if="props.row.tasks.length === 1 && props.row.tasks[0].compilation" :progress="props.row.tasks[0].compilation.progress"></progress-bar>
                                    <progress-bar v-else :progress="props.row.progress"></progress-bar> -->
                                    <progress-bar :progress="calculateProgress(props.row)"></progress-bar>
                                </template>
                                <template slot="created_at" slot-scope="props">
                                    <span>{{ $date(props.row.created_at).format('DD-MM-YYYY') }}</span><br>
                                    <small><font-awesome-icon :icon="['far', 'clock']" /> {{ $date(props.row.created_at).format('HH:mm') }}</small>
                                </template>
                                <template slot="updated_at" slot-scope="props">
                                    <span>{{ $date(props.row.updated_at).format('DD-MM-YYYY') }}</span><br>
                                    <small><font-awesome-icon :icon="['far', 'clock']" /> {{ $date(props.row.updated_at).format('HH:mm') }}</small>
                                </template>
                                <template slot="actions" slot-scope="props">
                                    <div class="btn-group float-right" role="group" aria-label="">
                                        <!-- <a title="Apri missione" href="javascript:;" class="btn btn-sm btn-success" @click="openDetail(props.row.id)">
                                            <font-awesome-icon :icon="['far', 'eye']" /> <span>APRI</span>
                                        </a> -->
                                        <a v-if="currentUser.type === 1" title="Elimina missione" href="javascript:;" class="btn btn-sm btn-danger" @click="deleteProject(props.row.id)">
                                            <font-awesome-icon icon="trash-alt" /> <span>ELIMINA</span>
                                        </a>
                                    </div>
                                </template>
                            </paginated-table>
                        </div>
                        <!-- <div class="card-footer">
                            <button @click="addProject" class="btn btn-success">
                                <font-awesome-icon icon="plus" size="sm" />&nbsp;NUOVA MISSIONE
                            </button>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <project-modal :project="currentProject" />
        <task-modal
            v-if="currentProject"
            :task="currentTask"
            :project="currentProject"
        />
    </section>
</template>
<script>
import {
    Task
} from '@/models/Task'
import { Project } from '@/models/Project'
import { mapGetters } from 'vuex'
import {
    GET_LIST,
    DELETE
} from '@/store/actions.type'
import {
    MODULE_NAME
} from '@/store/modules/projects.module'
const DEFAULT_QUERY = {
    _page: 1,
    _limit: 10,
    _sort: 'project_name',
    _asc: 1
}
export default {
    name: 'projects-list',
    mounted () {
        this.fetchProjects()
    },
    data () {
        return {
            currentTask: new Task(),
            currentProject: new Project(),
            columns: {
                project_status: {
                    label: 'Stato',
                    priority: 3,
                    align: 'center'
                },
                project_name: {
                    label: 'Nome missione',
                    sortable: true
                },
                creator_username: {
                    label: 'Creato da',
                    priority: 4,
                    sortable: true
                },
                company_username: {
                    label: 'Assegnato a',
                    priority: 3,
                    sortable: true
                },
                tasks_length: {
                    label: 'Tratte',
                    align: 'center'
                },
                progress: {
                    label: 'Avanzamento',
                    priority: 4,
                    align: 'center'
                },
                created_at: {
                    label: 'Data creazione',
                    sortable: true,
                    priority: 3
                },
                updated_at: {
                    label: 'Data modifica',
                    sortable: true,
                    priority: 5
                },
                actions: {
                    label: ''
                }
            }
        }
    },
    computed: {
        ...mapGetters([
            'currentUser'
        ]),
        ...mapGetters({
            projects: `${MODULE_NAME}/getList`
        }),
        query: {
            get () {
                return Object.keys(this.$route.query).length == 0 ? DEFAULT_QUERY : this.$route.query
            },
            set (new_query) {
                this.$router.replace({
                    query: {
                        ...new_query
                    }
                })
            }
        }
    },
    watch: {
        $route () {
            this.$store.dispatch(`${MODULE_NAME}/${GET_LIST}`, {
                query: this.query
            })
        }
    },
    methods: {
        // Se il progetto ha una solo task al suo interno, mostro anche il pulsante di compilazione della survey
        gotoSurvey (task) {
            let surveyUrlParams = task.metas.find(m => {
                return m.meta_key === 'survey_url_params'
            })
            if (surveyUrlParams) {
                window.location.href = `/survey?${surveyUrlParams.value}`
            } else {
                return false
            }
        },
        fetchProjects () {
            this.$store.dispatch(`${MODULE_NAME}/${GET_LIST}`, {
                query: this.query
            })
        },
        openDetail (projId) {
            this.$router.push({
                name: 'mission-detail',
                params: {
                    id: projId
                }
            })
        },
        addProject () {
            this.currentProject = new Project()
            // Se la missione non lo sta inserendo l'admin, setto come destinatario l'utente attuale;
            this.currentProject.project_company = this.currentUser.type === 1 ? null : this.currentUser.id
            this.$modal.show('project-modal')
        },
        addTask () {
            this.currentTask = new Task()
            this.$modal.show('task-modal')
        },
        editProject (proj) {
            this.currentProject = new Project(proj)
            this.$modal.show('project-modal')
        },
        deleteProject (projId) {
            event.stopPropagation()
            this.$swal({
                title: 'Sei sicuro?',
                text: 'Una volta eliminata non potrai più recuperare questa missione e i tasks ad essa associati!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, eliminala!'
            }).then((willDelete) => {
                if (willDelete.value) {
                    this.$store.dispatch(`${MODULE_NAME}/${DELETE}`, projId).then(() => {
                        this.fetchProjects()
                    })
                } else {
                    this.$swal('Bene!', 'La missione è salva!')
                }
            })
        },
        calculateProgress (row) {
            if (row.tasks.length) {
                let progress = 0
                row.tasks.forEach(task => {
                    progress += task.compilation ? task.compilation.progress : 0
                })
                return progress / row.tasks.length
            }
            return 0
        },
        rowClicked (e) {
            if (e.id) this.openDetail(e.id)
            return false
        }
    },
    components: {
        ProjectModal: () => import('./ProjectModal'),
        TaskModal: () => import('../tasks/TaskModal'),
        PaginatedTable: () => import('@/components/PaginatedTable'),
        ProgressBar: () => import('@/components/ProgressBar')
    }
}
</script>
